import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { ChevronRight } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
      as='header'
      bg='white'
      borderBottom='1px solid'
      borderColor='dark.D100'
      px={{ base: 4, md: 8 }}
    >
      <Flex
        dir='rtl'
        maxW='1200px'
        mx='auto'
        minH={{ base: '56px', md: '72px' }}
        align='center'
        justify='space-between'
        gap='12px'
      >
        <IconButton
          aria-label='go back'
          variant='outline'
          borderRadius='full'
          borderColor='dark.D150'
          color='dark.D700'
          size='sm'
          onClick={() => navigate(-1)}
          icon={<ChevronRight size={18} aria-hidden />}
        />
        <Text fontWeight={600} fontSize={{ base: '16px', md: '18px' }} color='dark.D900'>
          <FormattedMessage
            id='checkout.headerTitle'
            defaultMessage='Payment & booking confirmation'
          />
        </Text>
      </Flex>
    </Box>
  );
};
